export enum OfferType {
  GROSS_OF_REPAIRS = 'GROSS_OF_REPAIRS',
  NET_OF_REPAIRS = 'NET_OF_REPAIRS',
  WILLOW_OFFER = 'WILLOW_OFFER'
}
